import {
  GET_FAIL,
  GET_SUCCESS,
  GET_ALL_FAIL,
  GET_ALL_SUCCESS,
  SAVE_FAIL,
  SAVE_SUCCESS,
  UPDATE_SUCCESS,
  UPDATE_FAIL,
  DISSASOCIATE,
  DISSASOCIATE_SUCCESS,
  DISSASOCIATE_FAIL,
  GET_XML_TRANSSMITIONS_SUCCESS,
  GET_XML_TRANSSMITIONS_FAIL,
  TYPES_SUCCESS,
  TYPES_FAIL,
  UPDATE_TYPES_SUCCESS,
  UPDATE_TYPES_FAIL,
  GET_ALL,
  GET_BY_DOCUMENT_NUMBER,
  GET_BY_DOCUMENT_NUMBER_FAIL,
  GET_BY_DOCUMENT_NUMBER_SUCCESS,
  ASSOCIATE,
  ASSOCIATE_SUCCESS,
  ASSOCIATE_FAIL,
  OPEN,
  OPEN_SUCCESS,
  OPEN_FAIL,
  REJECT,
  REJECT_SUCCESS,
  REJECT_FAIL,
  SET_FILTER,
  CLEAR_FILTER,
  GET_ALL_STATES_SUCCESS,
  GET_ALL_STATES,
  GET_ALL_STATES_FAIL,
  GET_ALL_ASSIGNED,
  GET_ALL_ASSIGNED_SUCCESS,
  GET_ALL_ASSIGNED_FAIL,
  GET_ALL_NOTASSIGNED,
  GET_ALL_NOTASSIGNED_SUCCESS,
  GET_ALL_NOTASSIGNED_FAIL,
  SAVEASSIGNED_SUCCESS,
  SAVEASSIGNED_FAIL,
  SAVEASSIGNED,
  GET_ALL_PAGETYPE,
  GET_ALL_PAGETYPE_SUCCESS,
  GET_ALL_PAGETYPE_FAIL,
  GET_ALL_PROCCESS,
  GET_ALL_PROCCESS_SUCCESS,
  GET_ALL_PROCCESS_FAIL,
  SAVEATTACHS,
  SAVEATTACHS_SUCCESS,
  SAVEATTACHS_FAIL,
  GET_ALL_ASSIGNED_FOR_DOCUMENTID_FAIL,
  GET_ALL_ASSIGNED_FOR_DOCUMENTID_SUCCESS,
  GET_ALL_ASSIGNED_FOR_DOCUMENTID,
  SAVEAPROVAL,
  SAVEAPROVAL_SUCCESS,
  SAVEAPROVAL_FAIL,
  SAVEREACTIVE,
  SAVEREACTIVE_SUCCESS,
  SAVEREACTIVE_FAIL,
  GET_ALL_REJECTION_REASON,
  GET_ALL_REJECTION_REASON_FAIL,
  GET_ALL_REJECTION_REASON_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  assigned: [],
  notassigned: [],
  assignedForDocumentId: null,
  documentPageType: [],
  documentProccess: [],
  xls: [],
  entity: undefined,
  rejectionReason: [],
  types: [],
  error: {},
  fetching: false,
  fetchingEyes: false,
  mustBeUpdated: false,
  opening: false,
  rejecting: false,
  rejected: false,
  filter: {
    Name: "",
  },
};

const Inbound = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };

    case CLEAR_FILTER:
      return {
        ...state,
        filter: {
          Name: "",
        },
      };

    case GET_ALL:
      return {
        ...state,
        list: [],
        fetching: true,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_SUCCESS:
      return {
        ...state,
        list: action.payload,
        fetching: false,
        mustBeUpdated: false,
        rejected: false,
      };
    case GET_ALL_STATES:
      return {
        ...state,
        states: [],
        fetching: true,
      };
    case GET_ALL_STATES_SUCCESS:
      return {
        ...state,
        states: action.payload,
        fetching: false,
      };

    case GET_ALL_STATES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_ALL_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
        fetching: false,
      };
    case GET_XML_TRANSSMITIONS_SUCCESS:
      return {
        ...state,
        xls: action.payload,
        mustBeUpdated: false,
        fetching: false,
      };

    case GET_XML_TRANSSMITIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case TYPES_SUCCESS:
      return {
        ...state,
        types: action.payload,
        mustBeUpdated: false,
      };

    case TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };
    case UPDATE_TYPES_SUCCESS:
      return {
        ...state,
        mustBeUpdated: false,
      };

    case UPDATE_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case GET_BY_DOCUMENT_NUMBER:
      return {
        ...state,
        fetching: true,
      };

    case GET_BY_DOCUMENT_NUMBER_FAIL:
      return {
        ...state,
        fetching: false,
      };

    case GET_BY_DOCUMENT_NUMBER_SUCCESS:
      return {
        ...state,
        entity: action.payload,
        fetching: false,
      };

      case GET_ALL_REJECTION_REASON:
      return {
        ...state,
        fetching: true,
      };

    case GET_ALL_REJECTION_REASON_FAIL:
      return {
        ...state,
        fetching: false,
      };

    case GET_ALL_REJECTION_REASON_SUCCESS:
      return {
        ...state,
        rejectionReason: action.payload,
        fetching: false,
      };
    case GET_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case SAVE_SUCCESS:
      return {
        ...state,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case SAVE_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case UPDATE_SUCCESS:
      return {
        ...state,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case UPDATE_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };
    case DISSASOCIATE:
      return {
        ...state,
        fetchingEyes: true,
        error: {},
        result: action.payload,
      };
    case DISSASOCIATE_SUCCESS:
      return {
        ...state,
        fetchingEyes: false,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case DISSASOCIATE_FAIL:
      return {
        ...state,
        fetchingEyes: false,
        error: action.payload,
        mustBeUpdated: false,
      };

    case ASSOCIATE:
      return {
        ...state,
        fetching: true,
        error: {},
        result: action.payload,
      };
    case ASSOCIATE_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case ASSOCIATE_FAIL:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        mustBeUpdated: false,
      };

    case SAVEASSIGNED:
      return {
        ...state,
        fetching: true,
        error: {},
        result: action.payload,
      };
    case SAVEASSIGNED_SUCCESS:
      return {
        ...state,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case SAVEASSIGNED_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case SAVEATTACHS:
      return {
        ...state,
        fetching: true,
        error: {},
        result: action.payload,
      };
    case SAVEATTACHS_SUCCESS:
      return {
        ...state,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
        fetching: false,
      };

    case SAVEATTACHS_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
        fetching: false,
      };

    case SAVEAPROVAL:
      return {
        ...state,
        error: {},
        result: action.payload,
      };
    case SAVEAPROVAL_SUCCESS:
      return {
        ...state,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case SAVEAPROVAL_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case SAVEREACTIVE:
      return {
        ...state,
        error: {},
        result: action.payload,
      };
    case SAVEREACTIVE_SUCCESS:
      return {
        ...state,
        error: {},
        result: action.payload,
        mustBeUpdated: true,
      };

    case SAVEREACTIVE_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case OPEN:
      return {
        ...state,
        fetching: true,
        opening: true,
        error: {},
      };
    case OPEN_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: {},
        result: action.payload,
        opening: false,
        mustBeUpdated: true,
      };

    case OPEN_FAIL:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        mustBeUpdated: false,
        opening: false,
      };

    case REJECT:
      return {
        ...state,
        fetching: true,
        rejecting: true,
        error: {},
        rejected: false,
      };
    case REJECT_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: {},
        result: action.payload,
        rejecting: false,
        rejected: true,
        mustBeUpdated: true,
      };

    case REJECT_FAIL:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        mustBeUpdated: false,
        rejected: false,
        rejecting: false,
      };
    case GET_ALL_ASSIGNED:
      return {
        ...state,
        assigned: [],

        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_ASSIGNED_SUCCESS:
      return {
        ...state,
        assigned: action.payload,

        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_ASSIGNED_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };
    case GET_ALL_NOTASSIGNED:
      return {
        ...state,
        notassigned: [],
        fetching: true,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_NOTASSIGNED_SUCCESS:
      return {
        ...state,
        notassigned: action.payload,
        fetching: false,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_NOTASSIGNED_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
        fetching: false,
      };

    case GET_ALL_ASSIGNED_FOR_DOCUMENTID:
      return {
        ...state,
        assignedForDocumentId: null,
        fetchingEyes: true,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_ASSIGNED_FOR_DOCUMENTID_SUCCESS:
      return {
        ...state,
        assignedForDocumentId: action.payload,
        fetchingEyes: false,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_ASSIGNED_FOR_DOCUMENTID_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
        fetchingEyes: false,
      };

    case GET_ALL_PAGETYPE:
      return {
        ...state,
        documentPageType: [],

        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_PAGETYPE_SUCCESS:
      return {
        ...state,
        documentPageType: action.payload,

        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_PAGETYPE_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
      };

    case GET_ALL_PROCCESS:
      return {
        ...state,
        documentProccess: [],
        fetching: true,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_PROCCESS_SUCCESS:
      return {
        ...state,
        documentProccess: action.payload,
        fetching: false,
        mustBeUpdated: false,
        rejected: false,
      };

    case GET_ALL_PROCCESS_FAIL:
      return {
        ...state,
        error: action.payload,
        mustBeUpdated: false,
        fetching: false,
      };

    default:
      return state;
  }
};

export default Inbound;
